import { loginService } from "@/services/LoginServce";
import { useTokenStore } from "@/stores/token";

/**
 * ログイン画面で使用する処理呼び出しクラス
 */
class LoginView {
  /**
   * Login処理を行う
   *
   * @param id ユーザーID
   * @param password パスワード
   * @returns なし
   * @throws catchしたerrorオブジェクト
   */
  async login(id: string, password: string): Promise<void> {
    try {
      const userToken = await loginService.signIn(id, password);
      useTokenStore().setToken(
        userToken.id,
        userToken.idToken,
        userToken.idTokenExp,
        userToken.refreshToken
      );
    } catch (error) {
      console.error("ログイン失敗", error);
      throw error;
    }
  }
}

export const loginView = new LoginView();
